import type { ViewConfigTreeNode } from '@salescore/core'
import type { ModalFuncProps } from 'antd'
import { t } from 'i18next'

import { SearchSqlForm } from './SearchSqlForm'

interface BuildNodeSearchSqlFormModalPropertiesArguments {
  node: ViewConfigTreeNode
  editNode: (sql: string) => void
  onAfterFinish: () => void
}

export const buildNodeSearchSqlFormModalProperties = ({
  node,
  editNode,
  onAfterFinish,
}: BuildNodeSearchSqlFormModalPropertiesArguments): ModalFuncProps => ({
  icon: null,
  width: '90%',
  cancelText: t(`閉じる`),
  okButtonProps: { style: { display: 'none' } },
  style: {
    maxWidth: 1000,
  },
  closable: true,
  maskClosable: true,
  footer: null,
  content: (
    <SearchSqlForm
      title={t(`参照ブロックの検索設定`)}
      editNode={editNode}
      onAfterFinish={onAfterFinish}
      sql={node.override?.searchSql ?? ''}
    />
  ),
})
